import { RouteReuseStrategy, DetachedRouteHandle, ActivatedRouteSnapshot } from '@angular/router';

export class CustomReuseStrategy implements RouteReuseStrategy {
  handlers: { [key: string]: DetachedRouteHandle } = {};

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    // Determine if this route should be stored
    if (this.isExcludedRoute(route)) {
      return false;
    }
    return true;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    // Store the detached route
    if (!this.isExcludedRoute(route)) {
      this.handlers[route.routeConfig.path] = handle;
    }
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    // Determine if this route should be reattached
    if (this.isExcludedRoute(route)) {
      return false;
    }
    return !!this.handlers[route.routeConfig.path];
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
    // Retrieve the stored route
    if (this.isExcludedRoute(route)) {
      return null;
    }
    return this.handlers[route.routeConfig.path];
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    // Determine if the route should be reused
    return future.routeConfig === curr.routeConfig;
  }

  private isExcludedRoute(route: ActivatedRouteSnapshot): boolean {
    const url = route['_routerState'].url;
    // Exclude preview routes and any registry route except /registry and /registry/payment
    return url.includes('?preview=1') || 
           (url.includes('/registry') && url !== '/registry' && url !== '/registry/payment');
  }
}


// WEBPACK FOOTER //
// ./src/app/registry/custom-reuse-strategy.ts